import { Checkbox, FormControl, MenuItem } from "@material-ui/core"
import React from "react"

import { StyledSelect } from "../../../styles/Components/SingleInstance/JobListings"
import {
  IconChevron,
  IconUncheckedBox,
  IconCheckedBox,
} from "../../../utils/IconsList"

const MultiSelect = ({
  items,
  onChange: handleChange,
  placeholder,
  currentValue,
  setCurrentValue,
  ...props
}) => {
  const onChange = (e, child) => {
    setCurrentValue(e.target.value)
    handleChange?.(e, child)
  }

  const renderLabel = selected => {
    const getLabel = items.filter(item => selected.includes(item)) || []

    return getLabel?.length > 1
      ? `${getLabel?.length} ${placeholder} selected`
      : getLabel?.map(item => item)?.join(", ") || (
          <p style={{ opacity: ".5" }}>Select {placeholder}</p>
        )
  }

  return (
    <FormControl fullWidth>
      <StyledSelect
        multiple
        value={currentValue}
        displayEmpty={true}
        renderValue={selected => renderLabel(selected)}
        onChange={onChange}
        IconComponent={IconChevron}
        {...props}
      >
        {items?.map(item => {
          return (
            <MenuItem key={item} value={item}>
              <li>{item}</li>
              <Checkbox
                icon={<IconUncheckedBox />}
                checkedIcon={<IconCheckedBox />}
                checked={currentValue.includes(item)}
              />
            </MenuItem>
          )
        })}
      </StyledSelect>
    </FormControl>
  )
}

export default MultiSelect
